import { Expose, plainToClass } from 'class-transformer';

import { type Itinerary } from 'models/Journey';

export enum AirLuggageStatus {
  ACTIVE = 'active',
  ELIGIBLE = 'eligible',
  INELIGIBLE = 'ineligible',
  PAYOUT_FAILED = 'payout_failed',
  PROCESSING_PAYMENT = 'processing_payment',
  PAYOUT_SUCCESSFUL = 'payout_successful',
  UNKNOWN = 'unknown',
  PAYOUT_RETURNED = 'payout_returned',
  PARTNER_ERROR = 'partner_error',
  UNREGISTERED = 'unregistered',
  MANUAL_VERIFICATION_PENDING = 'manual_verification_pending',
  EXPIRED = 'expired',
}

export interface IAirLuggageJourney {
  id: number;
  status: AirLuggageStatus;
  journeyId: number;
  availableItineraries: Itinerary[];
  payoutAllowed?: boolean;
  payoutUpdateAllowed?: boolean;
  name: string;
  payoutRequested: boolean;
  payoutAmount: number;
  maxBags: number;
  ipidVersion?: string;
  transactionReference?: string;
}

export class AirLuggageJourney implements IAirLuggageJourney {
  @Expose() id: number;
  @Expose() status: AirLuggageStatus;
  @Expose() journeyId: number;
  @Expose() availableItineraries: Itinerary[];
  @Expose() payoutAllowed: boolean;
  @Expose() payoutUpdateAllowed: boolean;
  @Expose() name: string;
  @Expose() payoutRequested: boolean;
  @Expose() payoutAmount: number;
  @Expose() maxBags: number;
  @Expose() ipidVersion: string;
  @Expose() transactionReference: string;

  @Expose()
  get showNotification(): boolean {
    return (
      this.status === AirLuggageStatus.ELIGIBLE ||
      this.status === AirLuggageStatus.PAYOUT_FAILED ||
      this.status === AirLuggageStatus.PAYOUT_RETURNED
    );
  }
}

export function transformToAirLuggageJourneyClass(
  airLuggageData: IAirLuggageJourney,
): AirLuggageJourney {
  return plainToClass(AirLuggageJourney, airLuggageData);
}
